import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

import { PaymentMethodType } from './_types';

export const getPaymentMethodType = (type: string): string => {
  switch (type.toLowerCase()) {
    case 'card':
      return 'Credit Card';
    case 'us_bank_account':
      return 'Bank Account';
    default:
      return type;
  }
};

export const getPaymentMethodIcon = (type: string) => {
  switch (type.toLowerCase()) {
    case 'card':
      return icon({ name: 'credit-card', style: 'regular' });
    case 'us_bank_account':
      return icon({ name: 'building-columns', style: 'regular' });
    case 'cash':
      return icon({ name: 'money-bill', style: 'regular' });
    case 'check':
      return icon({ name: 'money-check', style: 'regular' });
    case 'free':
      return icon({ name: 'gift', style: 'regular' });
    case 'other':
      return icon({ name: 'money-bill-alt', style: 'regular' });
    default:
      return icon({ name: 'credit-card', style: 'regular' });
  }
};

export const getPaymentMethodsForCurrency = (
  currency: string
): PaymentMethodType[] => {
  if (currency === 'usd') {
    return ['card', 'us_bank_account'];
  } else if (currency === 'gbp') {
    return ['card'];
  } else if (currency === 'cad') {
    return ['card', 'acss_debit'];
  } else if (currency === 'eur') {
    return ['card', 'sepa_debit'];
  } else if (currency === 'aud') {
    return ['card', 'au_becs_debit'];
  }
  return ['card'];
};
